"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var AuthActions = _interopRequireWildcard(require("../../actions"));
var events = _interopRequireWildcard(require("../../constants/events"));
var _AuthContext = _interopRequireDefault(require("../../context/AuthContext"));
var AuthProvider = function AuthProvider(props) {
  var authManagerInstance = props.authManagerInstance,
    children = props.children;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onLoadUser = function onLoadUser() {
    dispatch(AuthActions.loadingUser());
  };
  var onUserFound = function onUserFound(user) {
    dispatch(AuthActions.userFound(user));
  };
  var onLoadUserError = function onLoadUserError() {
    dispatch(AuthActions.loadUserError());
  };
  var onUserSignedOut = function onUserSignedOut() {
    dispatch(AuthActions.userSignedOut());
  };
  var onSessionTerminated = function onSessionTerminated(error) {
    dispatch(AuthActions.sessionTerminated(error));
  };
  (0, _react.useEffect)(function () {
    // register the listeners
    authManagerInstance.on(events.LOADING_USER, onLoadUser);
    authManagerInstance.on(events.USER_FOUND, onUserFound);
    authManagerInstance.on(events.LOAD_USER_ERROR, onLoadUserError);
    authManagerInstance.on(events.USER_SIGNED_OUT, onUserSignedOut);
    authManagerInstance.on(events.SESSION_TERMINATED, onSessionTerminated); // return cleanup function to run on unmount

    return function () {
      authManagerInstance.removeListener(events.LOADING_USER, onLoadUser);
      authManagerInstance.removeListener(events.USER_FOUND, onUserFound);
      authManagerInstance.removeListener(events.LOAD_USER_ERROR, onLoadUserError);
      authManagerInstance.removeListener(events.USER_SIGNED_OUT, onUserSignedOut);
      authManagerInstance.removeListener(events.SESSION_TERMINATED, onSessionTerminated);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_AuthContext.default.Provider, {
    value: authManagerInstance
  }, _react.default.Children.only(children));
};
exports.AuthProvider = AuthProvider;
AuthProvider.propTypes = {
  authManagerInstance: _propTypes.default.shape({
    on: _propTypes.default.func.isRequired,
    removeListener: _propTypes.default.func.isRequired
  }).isRequired,
  children: _propTypes.default.node
};
AuthProvider.defaultProps = {
  children: null
};
var _default = AuthProvider;
exports.default = _default;